import { CustomerTrailerSearch } from '@pos-app/data';

export function sortCustomerTrailerSearchList(
  customerTrailerSearchList: CustomerTrailerSearch[]
) {
  return customerTrailerSearchList.sort((listA, listB) =>
    listA.AssetNumber < listB.AssetNumber ? -1 : 1
  );
}
